export const riskFreePromoKeys = {
	all: ['risk-free-promo'] as const,
};